import { Box, Stack } from '@mui/system';
import RoleLimitedVisibilityForm from './role-limited-visibility-form';
import { useQuery } from '@tanstack/react-query';
import { Navigate, useParams } from 'react-router-dom';
import { getAllRolesQuery, getDomainsQuery } from '../../../../api/users-api';
import { useUserSettings } from '../../../../utils/use-user-settings';
import { gPanelTiers } from '../../../../shared/gPanel-tiers';
import { pagesConfig } from '../../../../shared/pages-config';

import Divider from '@mui/material/Divider';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

export default function RoleLimitedVisibilityPage() {
  const { roleName } = useParams() as { roleName: string };
  const { changeLogRoles, usersTier, hasRoleWithLimitedVisibility } =
    useUserSettings();
  const { data: roles, isLoading } = useQuery(getAllRolesQuery());
  const currentRole = roles?.find((role) => role.roleName === roleName);
  const { data: domains } = useQuery(getDomainsQuery());

  const hasAtLeastEnterpriseTier =
    usersTier.rank >= gPanelTiers.enterprise.rank;

  if (!hasAtLeastEnterpriseTier && !hasRoleWithLimitedVisibility) {
    return (
      <Navigate to={`/${pagesConfig.roleManager.link}/${roleName}`} replace />
    );
  }

  if (isLoading || !currentRole || !roles) {
    return (
      <Box sx={{ position: 'relative', px: 2, pt: 2 }}>
        <Typography sx={{ fontSize: 24, textAlign: 'center', fontWeight: 400 }}>
          Limited User Visibility
        </Typography>

        <Button
          variant="contained"
          disabled={true}
          sx={{ position: 'absolute', top: 0, right: 0 }}
        >
          Save
        </Button>
        <Typography sx={{ fontSize: 14, fontWeight: 300, marginTop: 2 }}>
          Enable Limited Visibility for this Role
        </Typography>
        <Stack
          sx={{
            px: 4,
          }}
        >
          <Skeleton variant="text" width={210} height={40} />
        </Stack>
        <Divider sx={{ pt: 1 }} />
        <Typography sx={{ fontSize: 14, fontWeight: 300, marginTop: 2 }}>
          Summary of all sources currently included in the limited visibility
          list of this role:
        </Typography>
        <Stack
          sx={{
            px: 4,
          }}
        >
          <Skeleton variant="text" width={470} height={85} />
        </Stack>
        <Divider />
        <Typography sx={{ fontSize: 14, fontWeight: 300, marginTop: 2 }}>
          Orgs
        </Typography>
        <Stack
          sx={{
            px: 4,
          }}
        >
          <Skeleton variant="text" width={470} height={85} />
        </Stack>
        <Divider />
        <Typography sx={{ fontSize: 14, fontWeight: 300, marginTop: 2 }}>
          Roles
        </Typography>
        <Stack
          sx={{
            px: 4,
          }}
        >
          <Skeleton variant="text" width={470} height={85} />
        </Stack>
        <Divider />
        <Typography sx={{ fontSize: 14, fontWeight: 300, marginTop: 2 }}>
          Domains
        </Typography>
        <Stack
          sx={{
            px: 4,
          }}
        >
          <Skeleton variant="text" width={470} height={85} />
        </Stack>
        <Divider />
        <Typography sx={{ fontSize: 14, fontWeight: 300, marginTop: 2 }}>
          Users to Include
        </Typography>
        <Stack
          sx={{
            px: 4,
          }}
        >
          <Skeleton variant="text" width={470} height={85} />
        </Stack>
        <Divider />
        <Typography sx={{ fontSize: 14, fontWeight: 300, marginTop: 2 }}>
          Users to Exclude
        </Typography>
        <Stack
          sx={{
            px: 4,
          }}
        >
          <Skeleton variant="text" width={470} height={85} />
        </Stack>
      </Box>
    );
  }

  return (
    <RoleLimitedVisibilityForm
      role={currentRole}
      changeLogRoles={changeLogRoles}
      domains={domains}
      roles={roles}
    />
  );
}
